module.exports = __webpack_public_path__ + "static/media/logomob.1684230c.svg";